module.exports = __webpack_public_path__ + "img/logo透.949f73db.png";